const PKCE_VERIFIER_STORAGE_KEY = 'sso_pkce_verifier'

export function savePkceVerifier(verifier: string) {
  sessionStorage.setItem(PKCE_VERIFIER_STORAGE_KEY, verifier)
}

export function getPkceVerifier() {
  return sessionStorage.getItem(PKCE_VERIFIER_STORAGE_KEY)
}

export function clearPkceVerifier() {
  sessionStorage.removeItem(PKCE_VERIFIER_STORAGE_KEY)
}

/**
 * Кодирует переданный массив байтов в формат Base64URL.
 * @param str ArrayBuffer - входной массив байтов.
 * @returns string - Base64URL строка.
 */
export function base64urlencode(str: ArrayBuffer): string {
  const bytes = new Uint8Array(str)
  const binary = String.fromCharCode(...bytes)

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/**
 * Генерирует хэш SHA-256 для переданной строки.
 * @param plain string - входная строка.
 * @returns Promise<ArrayBuffer> - хэш SHA-256 в виде массива байтов.
 */
export function sha256(plain: string): Promise<ArrayBuffer> {
  const encoder = new TextEncoder()
  const data = encoder.encode(plain)
  return window.crypto.subtle.digest('SHA-256', data)
}

/**
 * Генерирует PKCE-челлендж из версификатора.
 * @param v string - версификатор.
 * @returns Promise<string> - PKCE-челлендж в формате Base64URL.
 */
export async function pkceChallengeFromVerifier(v: string): Promise<string> {
  const hashed = await sha256(v)
  return base64urlencode(hashed)
}

/**
 * Генерирует случайную строку длиной 56 символов (28 байтов).
 * @returns string - случайная строка.
 */
export function generateRandomString(): string {
  const array = new Uint32Array(32)
  window.crypto.getRandomValues(array)
  return Array.from(array, (dec) => `0${dec.toString(16)}`.slice(-2)).join('')
}
